// LanguageContext.js
import React, { createContext, useContext, useMemo, useState } from 'react';

// Default language - easily replaceable when preferences system is built
const DEFAULT_LANGUAGE = 'en';

const LanguageContext = createContext(null);

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const useCurrentLanguage = () => {
  const { language } = useLanguage();
  return language;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(DEFAULT_LANGUAGE);
  const value = useMemo(() => ({
    language,
    setLanguage,
  }), [language]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};